import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f8fb2b34&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f8fb2b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb2b34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8fb2b34')) {
      api.createRecord('f8fb2b34', component.options)
    } else {
      api.reload('f8fb2b34', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f8fb2b34&scoped=true&", function () {
      api.rerender('f8fb2b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HcsfLmTCT8Zd/JS/comp/PopupBox.vue"
export default component.exports